<template>
  <Listbox :model-value="modelValue" multiple @update:model-value="emit('update:modelValue', $event)">
    <div class="relative">
      <ListboxButton class="select flex w-40 items-center justify-between gap-2 text-left" :class="{ 'border-blue-300 text-blue-700': modelValue.length > 0 }">
        <span class="truncate">{{ label }}<span v-if="modelValue.length > 0" class="tabular-nums"> · {{ modelValue.length }}</span></span>
        <span class="text-[10px] text-gray-400" aria-hidden="true">▼</span>
      </ListboxButton>

      <ListboxOptions class="absolute left-0 top-full z-50 mt-1 max-h-72 w-56 overflow-y-auto rounded-md border border-gray-200 bg-white py-1 shadow-lg focus:outline-none">
        <ListboxOption v-for="option in options" :key="option.value" v-slot="{ active, selected }" :value="option.value" as="template">
          <li class="flex cursor-pointer items-center gap-2 px-3 py-1.5 text-sm" :class="{ 'bg-gray-50': active, 'text-gray-900': selected, 'text-gray-700': !selected }">
            <span
              class="inline-flex h-4 w-4 flex-shrink-0 items-center justify-center rounded border text-[10px] font-bold"
              :class="selected ? 'border-blue-600 bg-blue-600 text-white' : 'border-gray-300 bg-white'"
              aria-hidden="true"
            >
              {{ selected ? '✓' : '' }}
            </span>
            <span class="truncate">{{ option.label }}</span>
          </li>
        </ListboxOption>
        <li v-if="options.length === 0" class="px-3 py-1.5 text-sm text-gray-400">Nothing to choose from</li>
      </ListboxOptions>
    </div>
  </Listbox>
</template>

<script setup lang="ts">
  import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/vue';

  // Checkbox-style multi-select. The button names the filter and counts the picks; the picks
  // themselves are shown as removable pills by the owner, so the button stays one width.
  defineProps<{
    modelValue: string[];
    label: string;
    options: { value: string; label: string }[];
  }>();

  const emit = defineEmits<{ 'update:modelValue': [value: string[]] }>();
</script>
